import { Text, Link } from '@belong/ui';
import { STRINGS } from '../auth.strings';

interface Props {
  target?: '_self' | '_blank';
}

export function AgreeToTermsFooter({ target = '_blank' }: Props) {
  return (
    <>
      <Text variant="p1" className="text-center">
        {STRINGS['terms_footer.first_line']}
      </Text>
      <Text as="span" variant="p1" className="block w-full text-center">
        <Link href="/privacy-policy" variant="text" target={target}>
          <Text variant="p1" fontWeight="semibold">
            {STRINGS['terms_footer.privacy']}
          </Text>
        </Link>{' '}
        {STRINGS['terms_footer.and']}{' '}
        <Link href="/terms-and-conditions" variant="text" target={target}>
          <Text variant="p1" fontWeight="semibold">
            {STRINGS['terms_footer.terms']}
          </Text>
        </Link>
      </Text>
    </>
  );
}
